import { buildStorefrontApiPath, api } from "@/lib/api";
import { mapHomeSections } from "@/lib/storefront-acl";
import type { HomeSection } from "@/features/home/types";

/**
 * Secciones del inicio. La API siempre las manda (las del editor o, si la
 * tienda no configuró su inicio, las por defecto) con la misma forma; el
 * mapeo vive en storefront-acl.
 */
export async function fetchHomeSections(): Promise<HomeSection[]> {
  const res = await api.get(buildStorefrontApiPath("/home"));
  return mapHomeSections(res.data);
}

/**
 * H3 — la misma query para el prefetch del gate (arranca junto al bootstrap)
 * y para HomePage. Con 30 s de vigencia, montar HomePage sobre el prefetch no
 * vuelve a pedir /home (con 0, el montaje disparaba un segundo pedido).
 */
export const homeSectionsQuery = {
  queryKey: ["home:sections"],
  queryFn: fetchHomeSections,
  staleTime: 30_000,
} as const;
